import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  border-radius: 16px;
  margin-bottom: 16px;
`;

export const Separator = styled.div`
  height: 1px;
  background: #e7ecf6;
  margin-bottom: 12px;
`;

export const Title = styled.h3`
  margin: 0;
  padding: 0 16px 12px;
  font-size: 14px;
  color: #6f7d95;
  font-weight: 800;
`;

export const List = styled.div`
  display: grid;
  gap: 8px;
  padding: 0 16px 12px;
`;

export const Card = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  background: #fff;
  text-align: left;
  padding: 16px 12px;
  cursor: pointer;
  box-sizing: border-box;
`;

export const PlanIcon = styled.img`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  margin-right: 12px;
  object-fit: contain;
`;

export const TextBlock = styled.div`
  flex: 1;
  min-width: 0;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;

export const TagImg = styled.img`
  width: 30px;
  height: 14px;
  object-fit: contain;
`;

export const CardTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  color: #111827;
`;

export const CardInfo = styled.div`
  margin-top: 4px;
  font-size: 14px;
  line-height: 16px;
  color: #6f7d95;
`;

export const Chevron = styled.span`
  flex-shrink: 0;
  margin-left: 8px;
  color: #2a70f4;
  font-size: 22px;
  font-weight: 300;
  line-height: 1;
`;

